import React, { useEffect, useState } from "react";
import "./PayoutCertificate.scss";
import certificateImg from "../../assets/images/profit_split.jpg";
import { Modal } from "@mui/material";
import downloadIcon from "../../assets/icons/download.svg";
import closeIcon from "../../assets/icons/cross-gray.svg";
import html2canvas from "html2canvas";
import { FormatUSD } from "../../utilities/string";
import ShareCertiWithSocialmedia from "./ShareCertiWithSocialmedia";

function PayoutCertificates({ data, publicShareTrue = false }) {
  const certificate = data;
  const [open, setOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(
    publicShareTrue ? data : null
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = (certificate) => {
    setSelectedCertificate(certificate);
    setOpen(true); // Open modal
    setImageLoaded(false); // Reset imageLoaded for new modal
  };

  const handleClose = () => {
    setOpen(false); // Close modal
    setSelectedCertificate(null);
  };

  const handleDownload = (link, title) => {
    const anchor = document.createElement("a");
    anchor.href = link;
    anchor.download = title;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  // Function to download the certificate with image and details
  const downloadCertificateWithDetails = () => {
    const certificateElement = document.getElementById("certificateContainer");

    if (certificateElement) {
      html2canvas(certificateElement, {
        scale: 4, // Ensure high resolution
        useCORS: true, // Enable cross-origin images
      }).then((canvas) => {
        // Create a new canvas for fixed dimensions
        const resizedCanvas = document.createElement("canvas");
        resizedCanvas.width = 1968; // Fixed width
        resizedCanvas.height = 1483; // Fixed height

        const context = resizedCanvas.getContext("2d");
        context.drawImage(
          canvas,
          0,
          0,
          canvas.width,
          canvas.height,
          0,
          0,
          resizedCanvas.width,
          resizedCanvas.height
        );

        // Convert resized canvas to image
        const dataUrl = resizedCanvas.toDataURL("image/png");

        // Trigger download
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${selectedCertificate?.name}_certificate.png`;
        link.click();
      });
    } else {
      console.error("Certificate element not found for download.");
    }
  };

  const handleSmallDownload = () => {
    // Open the modal first
    setOpen(true);
    setSelectedCertificate(certificate);

    setTimeout(() => {
      // Trigger the download automatically
      downloadCertificateWithDetails();
    }, 300); // Adding a slight delay to ensure the modal is opened before the download happens
  };
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  return (
    <>
      {!publicShareTrue && (
        <div
          key={certificate.id}
          className="small_certificate_container"
          onClick={() => handleOpen(certificate)}
        >
          <div className="certificate_container_header">
            <span>
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  handleSmallDownload();
                }}
                src={downloadIcon}
                alt=""
                className="download_icon"
              />
            </span>
            <h3 className="certificate_title">{certificate?.title}</h3>
          </div>
          <div className="certificateImgContainer payoutCertificateContainer">
            <img
              src={certificateImg}
              alt="Certificate"
              className="small_certificate_image"
              style={{ cursor: "pointer" }}
            />
            <div className="small_certificate_name">{certificate?.name}</div>
            <div className="small_certificate_amount">
              {FormatUSD(certificate?.amount)}
            </div>
            <div className="small_certificate_date">
              {certificate?.created_at}
            </div>
          </div>
          <div
            className="frame-btn-container"
            style={{ marginTop: "10px", textAlign: "center" }}
          >
            <a
              href="https://fundedaward.com/products/ac-award?ta_aff=capital"
              target="_blank"
              rel="noreferrer"
              className="frame-certificate-btn"
            >
              Frame Certificate
            </a>
          </div>
        </div>
      )}

      {/* Modal Section */}
      {publicShareTrue ? (
        <div
          className={`${publicShareTrue ? "stage1certificateCardOverlayShare" : ""
            } certificate-modal`}
        >
          <div className="modal-content">
            <div
              className="certificate_container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="certificate_container_header">
                <span>
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadCertificateWithDetails();
                    }}
                    src={downloadIcon}
                    alt=""
                    className="download_icon"
                  />
                </span>
                <h3 className="certificate_title">
                  {selectedCertificate?.title}
                </h3>
                {!publicShareTrue && (
                  <img
                    onClick={handleClose}
                    src={closeIcon}
                    alt=""
                    className="close_icon"
                  />
                )}
              </div>

              {/* Certificate Image */}
              <div className="certificatePopImage" id="certificateContainer">
                <img
                  src={certificateImg}
                  alt="Certificate"
                  className="certificate_image"
                  style={{ cursor: "pointer" }}
                  onLoad={() => setImageLoaded(true)}
                />

                {/* Render content only after image loads */}
                {imageLoaded && (
                  <>
                    <div className="certificate_name">
                      {selectedCertificate?.name}
                    </div>
                    <div className="certificate_amount">
                      {FormatUSD(selectedCertificate?.amount)}
                    </div>
                    <div className="certificate_date">
                      {selectedCertificate?.created_at}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Modal open={open || publicShareTrue}>
          <div
            className={`${publicShareTrue ? "stage1certificateCardOverlayShare" : ""
              } certificate-modal`}
            onClick={handleClose}
          >
            <div className="modal-content">
              <div
                className="certificate_container"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="certificate_container_header certificate_popModal_header">
                  <div className="topSection">
                    <h3 className="certificate_title">
                      {selectedCertificate?.title}
                    </h3>
                  </div>
                  <div className="bottomSection">
                    <span>
                      <img
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadCertificateWithDetails();
                        }}
                        src={downloadIcon}
                        alt=""
                        className="download_icon"
                      />
                    </span>

                    <div
                      className="rightSection"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <ShareCertiWithSocialmedia data={selectedCertificate} />
                      {!publicShareTrue && (
                        <img
                          onClick={handleClose}
                          src={closeIcon}
                          alt=""
                          className="close_icon"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Certificate Image */}
                <div className="certificatePopImage" id="certificateContainer">
                  <img
                    src={certificateImg}
                    alt="Certificate"
                    className="certificate_image"
                    style={{ cursor: "pointer" }}
                    onLoad={() => setImageLoaded(true)}
                  />

                  {/* Render content only after image loads */}
                  {imageLoaded && (
                    <>
                      <p className="certificate_name">
                        {selectedCertificate?.name}
                      </p>
                      <p className="certificate_amount">
                        {FormatUSD(selectedCertificate?.amount)}
                      </p>
                      <p className="certificate_date">
                        {selectedCertificate?.created_at}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default PayoutCertificates;
